import {
  allCityList,
  codeTableAll,
  listTreeStudentSourceDistrict,
  majorLists,
  deptLists,
  systemMajorLists,
  systemSchoolLists
} from "@/api"
import {getToken} from "common/auth"
const baseStore = {
  namespaced:true,
  state: {
    current: Date.now(), // 当前时间
    name:'pedestal',
    codeAllList:[],
    codeAllMap:{},
    cityList:[],
    cityListTwo:[],
    cityMap:{},
    studentSourceCityList:[],
    studentSourceCityMap:{},
    companyList:[],  //学院
    companyMap:[],
    majorList:[], //专业
    majorMap:{},
    webCount:{
      hitsAll:0,
      hitsDay:0
    },
    $socket:null,
    originAuditList:[],
    processDialogShow:false,
    msgCount:0,
    todoMessageTotal:{
      'bs-employment':0,
      'bs-choose':0,
      'bs-forum':0,
      'bs-user':0,
      'bs-job':0,
    }
  },
  getters: {
  },
  mutations: {
    updateTodoMsgTotal(state,obj){
      state.todoMessageTotal[obj.key] = obj.num
    },
    updateOriginAuditList(state,data){
      if(data){
        state.originAuditList.push(data)
      }else{
        state.originAuditList = []
      }
    },
    updateProcessDialog(state,data){
      state.processDialogShow = data
    },
    updateMsgCount(state,count){
      state.msgCount = count
    },
    updateSocket(state,socket){
      state.$socket = socket
    },
    updateName(state,name){
      state.name = name
    },
    setMajorList:(state,data)=>{
      state.majorList = data
    },
    setMajorMap:(state,data)=>{
      state.majorMap = data
    },
    setCompanyList:(state,data)=>{
      state.companyList = data
    },
    setCompanyMap:(state,data)=>{
      state.companyMap = data
    },
    setSchoolCodeList:(state,data)=>{
      state.codeAllList['m_school'] = data
    },
    setSchoolCodeMap:(state,data)=>{
      state.codeAllMap['m_school'] = data
    },
    setMajorCodeList:(state,data)=>{
      state.codeAllList['m_major_code'] = data
    },
    setMajorCodeMap:(state,data)=>{
      state.codeAllMap['m_major_code'] = data
    },
    setCodeList:(state,data)=>{
      state.codeAllList = data
    },
    setCodeMap:(state,data)=>{
      state.codeAllMap = data
    },
    setCityList:(state,data)=>{
      state.cityList = data
    },
    setCityMap:(state,data)=>{
      let obj = {}
      data.map(item=>{
        obj[item.code] = item.name
        item.districtVOList.map(it=>{
          obj[it.code] = it.name
          it.districtVOList.map(i=>{
            obj[i.code] = i.name
          })
        })
      })
      state.cityMap = obj
    },
    setCityListTwo:(state,data)=>{
      state.cityListTwo = data
    },
    setStudentSourceCityList:(state,data)=>{
      state.studentSourceCityList = data
    },
    setStudentSourceCityMap:(state,data)=>{
      let obj = {}
      data.map(item=>{
        obj[item.code] = item.name
        item.districtVOList.map(it=>{
          obj[it.code] = it.name
        })
      })
      state.studentSourceCityMap = obj
    },
    updateWebCount:(state,data)=>{
      state.webCount = data
    }
  },
  actions: {
    updateUserName({commit},name){
      commit('updateName',name)
    },
    updateTodoMsgTotalActive({commit},obj){
      commit('updateTodoMsgTotal',obj)
    },
    deptListsData({commit}){
      deptLists().then(res => {
        for (let i = 0; i < res.data.length; i++) {
          res.data[i].code = res.data[i].deptCode
          res.data[i].name = res.data[i].fullName
        }
        let obj = {}
        res.data.map(item=>{
          obj[item.code] = item.name
        })
        commit('setCompanyList',res.data)
        commit('setCompanyMap',obj)
      })
    },
    majorListsData({commit}){
      majorLists().then(res => {
        for (let i = 0; i < res.data.length; i++) {
          res.data[i].code = res.data[i].majorCode
          res.data[i].name = res.data[i].majorName
        }
        let obj = {}
        res.data.map(item=>{
          obj[item.code] = item.name
        })
        commit('setMajorList',res.data)
        commit('setMajorMap',obj)
      })
    },
    getSchoolCodeData({commit}){
      systemSchoolLists().then(res => {
        for (let i = 0; i < res.data.length; i++) {
          res.data[i].code = res.data[i].schoolCode
          res.data[i].name = res.data[i].schoolName
        }
        let obj = {}
        res.data.map(item=>{
          obj[item.code] = item.name
        })
        commit('setSchoolCodeList',res.data)
        commit('setSchoolCodeMap',obj)
      })
    },
    getMajorCodeData({commit}){
      systemMajorLists().then(res => {
        for (let i = 0; i < res.data.length; i++) {
          res.data[i].code = res.data[i].majorCode
          res.data[i].name = res.data[i].majorName
        }
        let obj = {}
        res.data.map(item=>{
          obj[item.code] = item.name
        })
        commit('setMajorCodeList',res.data)
        commit('setMajorCodeMap',obj)
      })
    },
    getCodeData({commit,dispatch}){
      return new Promise((resolve)=>{
        codeTableAll().then(res=>{
          let codeList = {}
          res.data.map(item=>{
            codeList[item.tableName] = item.webCodeDataVOList
          })
          console.log(codeList)
          commit('setCodeList',codeList)
          let codeMap = {}
          res.data.map(item=>{
            codeMap[item.tableName] = {}
            item.webCodeDataVOList.map(items=>{
              codeMap[item.tableName][items.code] = items.name
            })
          })
          console.log(codeMap)
          commit('setCodeMap',codeMap)
          resolve()
        })
        dispatch('deptListsData')
        dispatch('majorListsData')
        dispatch('getSchoolCodeData')
        dispatch('getMajorCodeData')
      })
    },
    getCityData({commit}){
      return new Promise((resolve)=>{
        allCityList().then(res=>{
          commit('setCityList',res.data)
          commit('setCityMap',JSON.parse(JSON.stringify(res.data)))
          let list = JSON.parse(JSON.stringify(res.data))
          list = list.map(item=>{
            item.districtVOList = item.districtVOList.map(it=>{
              it.districtVOList = null
              return it
            })
            return item
          })
          commit('setCityListTwo',list)
          resolve()
        })
      })
    },
    getStudentSourceCityData({commit}){
      return new Promise((resolve)=>{
        listTreeStudentSourceDistrict().then(res=>{
          commit('setStudentSourceCityList',res.data)
          commit('setStudentSourceCityMap',JSON.parse(JSON.stringify(res.data)))
          resolve()
        })
      })
    },
    initSocket({commit,state}){
      if (!window.WebSocket) {
        window.WebSocket = window.MozWebSocket;
        return;
      }
      let $socket = new WebSocket(
        process.env.NODE_ENV == "development"
          ? `wss://ys.91boshuo.com/bwss/`:
          process.env.NODE_ENV == "test"?"wss://ys.91boshuo.com/bwss/": `ws://jiuye.xjy.edu.cn:8092/bwss/`
      );
      commit('updateSocket',$socket)
      state.$socket.onmessage = (res) => {
        if(res){
          let data = JSON.parse(res.data);
          if(data.type == 'BIM.TYPES.MSG_AUDIT_SCHEDULE'){
            commit('updateOriginAuditList',JSON.parse(data.payload.text))
          }
          if(data.type == 'BIM.TYPES.MSG_AUDIT_FINISH'){
            commit('updateProcessDialog',true)
          }
          if(data.type == 'BIM.TYPES.MSG_NOTE_COUNT'){
            commit('updateMsgCount',Number(data.payload.text))
          }
          if(data.type == 'BIM.TYPES.EMPLOYMENT_TODO_COUNT'){
            commit('updateTodoMsgTotal',{key:'bs-employment',num: Number(data.payload.text)})
          }
          if(data.type == 'BIM.TYPES.USER_TODO_COUNT'){
            commit('updateTodoMsgTotal',{key:'bs-user',num: Number(data.payload.text)})
          }
          if(data.type == 'BIM.TYPES.JOB_TODO_COUNT'){
            commit('updateTodoMsgTotal',{key:'bs-job',num: Number(data.payload.text)})
          }
          if(data.type == 'BIM.TYPES.FORUM_TODO_COUNT'){
            commit('updateTodoMsgTotal',{key:'bs-forum',num: Number(data.payload.text)})
          }
          if(data.type == 'BIM.TYPES.CHOOSE_TODO_COUNT'){
            commit('updateTodoMsgTotal',{key:'bs-choose',num: Number(data.payload.text)})
          }
        }
        console.log("onmessage", res);
      };
      state.$socket.onopen = (res) => {
        if(getToken()){
          state.$socket.send(JSON.stringify({type:'BIM.TYPES.MSG_LOGIN',payload:{token:getToken()}}))
        }
        heartCheck.start();
        console.log("onopen", res);
      };
      state.$socket.onclose = (res) => {
        // heartCheck.stop();
        clearInterval(heartCheck.timeoutObj);
        reconnect();
        console.log("onclose", res);
      };
      state.$socket.onerror = (res) => {
        console.log("onerror", res);
        reconnect()
      };

      //重试连接socket
      function reconnect() {
        let $socket = new WebSocket(
          process.env.NODE_ENV == "development"
            ? `wss://ys.91boshuo.com/bwss/`:
            process.env.NODE_ENV == "test"?"wss://ys.91boshuo.com/bwss/": `ws://jiuye.xjy.edu.cn:8092/bwss/`
        );
        commit('updateSocket',$socket)
      }
      var heartCheck = {
        timeout: 30000,
        timeoutObj: null,
        start: function () {
          console.log(getNowTime() + " Socket 心跳检测");
          this.timeoutObj && clearInterval(this.timeoutObj);
          this.timeoutObj = setInterval(function () {
            //这里发送一个心跳，后端收到后，返回一个心跳消息，
            //onmessage拿到返回的心跳就说明连接正常
            console.log(getNowTime() + " Socket 心跳发送");
            state.$socket.send("连接成功");
          }, this.timeout);
        },
        stop: function () {
          this.timeoutObj && clearInterval(this.timeoutObj);
        },
      };
      function p(s) {
        return s < 10 ? "0" + s : s;
      }
      function getNowTime() {
        var myDate = new Date();
        //获取当前年
        var year = myDate.getFullYear();
        //获取当前月
        var month = myDate.getMonth() + 1;
        //获取当前日
        var date = myDate.getDate();
        var h = myDate.getHours(); //获取当前小时数(0-23)
        var m = myDate.getMinutes(); //获取当前分钟数(0-59)
        var s = myDate.getSeconds();
        return (
          year +
          "-" +
          p(month) +
          "-" +
          p(date) +
          " " +
          p(h) +
          ":" +
          p(m) +
          ":" +
          p(s)
        );
      }
    }
  }
}
export default baseStore
